import { Grid, PropsOf } from '@fluidtruck/core';
import { CustomDomComponent, motion } from 'framer-motion';

export const MotionGrid: CustomDomComponent<PropsOf<typeof Grid>> =
  'custom' in motion ? (motion as any).custom(Grid) : (motion as any)(Grid);
